export interface permissions_type {
  [key: string]: Int32Array;
}

const permissions: permissions_type = {};

const level: string[] = [];

export { permissions, level };
